import { Box, Button, LinearProgress, Typography } from "@material-ui/core";
import React from "react";
import Component from "src/shared/components/Component";
import Page from "src/shared/components/Page";
import withAxios from "src/shared/components/withAxios";
import { ISchoolIdRequest } from "src/api/types";
import SeasonsSportEditor from "src/features/director/pages/seasons/components/seasons-sport-editor/SeasonsSportEditor";
import { DefaultSettingsModal } from "./components/default-settings-modal/DefaultSettingsModal";
import {
  CUSTOMIZE_SEASONS_BUTTON_LABEL,
  DEFAULT_SEASONS_SETTINGS,
  SAVE_FAILURE,
  // SAVE_SUCCESS,
  SEASONS_PAGE_HEADER,
  SEASONS_PAGE_SUBTITLE,
} from "./constants";
import { IProps, ISeasonsPageState } from "./types";
import { getIsSchoolDefault } from "./utils/getIsSchoolDefault/getIsSchoolDefault";
import { parseSchoolId } from "./utils/parseSchoolId/parseSchoolId";
import { Alert } from "@material-ui/lab";

export default withAxios(
  class extends Component<IProps, ISeasonsPageState> {
    public readonly state = this.buildState({
      isDefaultSettingsModalOpen: false,
    });

    public componentDidMount() {
      this.props.loadSeasons(true);
    }

    public render() {
      const {
        defaultSeasons,
        loadingSeasonsResponse,
        loadSeasons,
        saving,
        saved,
        schoolId,
        schoolName,
        schoolSeasonActive,
        seasons,
        seasonsChange,
        setSeason,
        sports,
        school,
      } = this.props;
      const { isDefaultSettingsModalOpen } = this.state;
      const isSchoolDefault = getIsSchoolDefault({
        defaultSeasons,
        schoolSeasonActive,
      });
      const openDefaultSettingsModal = () => {
        this.setState({ isDefaultSettingsModalOpen: true });
      };
      const closeDefaultSettingsModal = () => {
        this.setState({ isDefaultSettingsModalOpen: false });
      };

      return (
        <Page header={SEASONS_PAGE_HEADER} subtitle={SEASONS_PAGE_SUBTITLE}>
          {isSchoolDefault && (
            <Box display="flex" flexDirection="column" gridGap="1.5rem">
              <Typography variant="h5">{DEFAULT_SEASONS_SETTINGS}</Typography>
              <Box>
                <Button
                  onClick={this.setSeasonsToCustom}
                  color="primary"
                  variant="contained"
                >
                  {CUSTOMIZE_SEASONS_BUTTON_LABEL}
                </Button>
              </Box>
            </Box>
          )}
          {!isSchoolDefault && (
            <>
              <Box display="flex" flexDirection="column" gridGap="1.5rem">
                <Box>
                  <Box height="1px">{saving && <LinearProgress />}</Box>
                  {/* {saved && <Alert severity="success">{SAVE_SUCCESS}</Alert>} */}
                  {!saving && !saved && (
                    <Alert severity="error">{SAVE_FAILURE}</Alert>
                  )}
                </Box>
                <SeasonsSportEditor
                  defaultSeasons={defaultSeasons}
                  schoolId={parseSchoolId(schoolId)}
                  seasons={seasons}
                  loadingSeasonsResponse={loadingSeasonsResponse}
                  loadSeasons={loadSeasons}
                  openDefaultSettingsModal={openDefaultSettingsModal}
                  sports={sports}
                  seasonsChange={seasonsChange}
                  setSeason={setSeason}
                  school={school}
                />
              </Box>
              <DefaultSettingsModal
                closeDefaultSettingsModal={closeDefaultSettingsModal}
                isDefaultSettingsModalOpen={isDefaultSettingsModalOpen}
                schoolName={schoolName}
                setSeasonsToDefault={this.setSeasonsToDefault}
              />
            </>
          )}
        </Page>
      );
    }

    private setSeasonsToDefault = async () => {
      await this.runCancellableStatefulAsync(
        this,
        {},
        {
          isDefaultSettingsModalOpen: false,
        },
        async () => {
          const { schoolId, loadSeasons } = this.props;
          if (schoolId === undefined) {
            return;
          }
          await this.buildDeleteWithParams<void, ISchoolIdRequest>(
            this,
            `seasonDeactivateSchool`
          )({
            schoolId,
          });
          loadSeasons(true);
        },
        () => {
          window.alert("Failed to set back to default");
        }
      );
    };

    private setSeasonsToCustom = async () => {
      await this.runCancellableStatefulAsync(
        this,
        {},
        {},
        async () => {
          const { schoolId, loadSeasons } = this.props;
          if (schoolId === undefined) {
            return;
          }
          await this.buildPut<ISchoolIdRequest, void>(
            this,
            `seasonActivateSchool`
          )({
            schoolId,
          });
          loadSeasons(true);
        },
        () => {
          window.alert("Failed to start editing");
        }
      );
    };
  }
);



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/seasonsPage/SeasonsPage.tsx